module.exports = __webpack_public_path__ + "img/11-1.4f37881c.png";